import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { LanguageCode } from '@/i18n/languages';

export type ThemeSetting = 'system' | 'dark' | 'light';

interface SettingsState {
  language: LanguageCode;
  theme: ThemeSetting;
  sound: boolean;
  haptics: boolean;
  /** New games: the shot clock waits at 24 after a basket until the throw-in is touched. */
  holdShotClock: boolean;
  set: (patch: Partial<Omit<SettingsState, 'set'>>) => void;
}

export const useSettings = create<SettingsState>()(
  persist(
    (set) => ({
      language: 'en',
      theme: 'system',
      sound: true,
      haptics: true,
      holdShotClock: true,
      set: (patch) => set(patch),
    }),
    {
      name: 'hoopscope.settings.v1',
      storage: createJSONStorage(() => localStorage),
      partialize: ({ set: _set, ...rest }) => rest,
    },
  ),
);

export function applyTheme(theme: ThemeSetting): void {
  const root = document.documentElement;
  if (theme === 'system') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', theme);
}
